module.exports = __webpack_public_path__ + "static/img/eemo-logo-small.5893134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eemo-logo-small.png
// module id = akBK
// module chunks = 1